export enum TaskState {
  Created = 'Created',
  Approved = 'Approved',
  Pending = 'Pending',
  Running = 'Running',
  Successful = 'Successful',
  Failed = 'Failed',
  TimedOut = 'TimedOut'
}
